export default "__VITE_ASSET__Btuh6Pws__"